import { IconProps } from ".";
import Icon from "./assets/delete_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Delete(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
